<template>
	<div class="CuttingPrint">
		<common-body aside="6">
			<div slot="commonMain" class="quotation_box" v-loading.lock="loadingStatus">
				<div v-if="ready">
					<div class="quotation_header no-print">
						<el-row type="flex" align="middle" justify="space-between" class="header_content">
							<el-row type="flex" align="middle" class="location_box">
								<div class="location_icon">
									<i class="el-icon-s-promotion"></i>
								</div>
								<el-row type="flex" align="middle" class="location_text">
									<div>当前位置：</div>
									<el-button @click="goBack" type="text">生产查询</el-button>
									<div class="location_xie">/</div>
									<div>{{ isMerge ? '揉单切料打印预览' : '切料优化打印预览' }}</div>
								</el-row>
							</el-row>
							<el-row type="flex" align="middle" class="header_r">
								<div @click="toImg" class="header_btn header_btn1">立即打印</div>
							</el-row>
						</el-row>
					</div>
					<div ref="offerPrint" class="quotation_form cutting-print-sheet">
						<div class="offer_header">
							<div class="offer_title">{{ printTitle }}</div>
							<div class="offer_logo">
								<img src="@/assets/maitu-logo.svg" />
							</div>
						</div>
						<div class="customer_info">
							<template v-if="isMerge">
								<div class="customer_l">
									<div class="customer_text"><span>揉单数量：</span>{{ orderIds.length }} 单</div>
									<div class="customer_text"><span>涉及单号：</span>{{ orderNumbersText }}</div>
								</div>
								<div class="customer_r">
									<div class="customer_text"><span>打印日期：</span>{{ printDate }}</div>
									<div class="customer_text" v-if="detail"><span>制单人：</span>{{ detail.user_name || '—' }}</div>
								</div>
							</template>
							<template v-else-if="detail">
								<div class="customer_l">
									<div class="customer_text"><span>客户名称：</span>{{ detail.customer_id }}</div>
									<div class="customer_text"><span>收货地址：</span>{{ detail.receiving_address }}</div>
									<div class="customer_b">
										<div class="customer_text"><span>联系人：</span>{{ detail.contacts }}</div>
										<div class="customer_text"><span>联系电话：</span>{{ detail.contacts_phone }}</div>
									</div>
								</div>
								<div class="customer_r">
									<div class="customer_text"><span>单号：</span>{{ detail.order_number }}</div>
									<div class="customer_text"><span>下单日期：</span>{{ detail.createTime }}</div>
									<div class="customer_text"><span>制单人：</span>{{ detail.user_name || '—' }}</div>
								</div>
							</template>
						</div>

						<div class="cutting-summary-bar" v-if="cuttingPlan">
							<div class="cutting-summary-bar__item">
								<span class="k">预估原料合计</span>
								<span class="v">{{ cuttingPlan.total_stock_count }} 根</span>
							</div>
							<div class="cutting-summary-bar__item">
								<span class="k">加工尺寸总长</span>
								<span class="v">{{ cuttingPlan.total_piece_length }} mm</span>
							</div>
							<div class="cutting-summary-bar__item">
								<span class="k">SKU 组数</span>
								<span class="v">{{ cuttingPlan.group_count }}</span>
							</div>
							<div class="cutting-summary-bar__item" v-if="cuttingPlan.warning_count">
								<span class="k">告警</span>
								<span class="v v--warn">{{ cuttingPlan.warning_count }}</span>
							</div>
						</div>

						<div v-if="!loadingStatus && cuttingPlan && !cuttingPlan.groups.length" class="cutting-empty">
							当前订单没有可按长度切料的明细（需有效加工尺寸）
						</div>

						<div
							v-for="(group, gi) in (cuttingPlan && cuttingPlan.groups) || []"
							:key="group.key"
							class="cutting-group"
							:class="{ 'cutting-group--break': gi > 0 }">
							<div class="cutting-group__head">
								<div class="cutting-group__title">
									<span class="cutting-group__idx">{{ gi + 1 }}.</span>
									{{ group.label }}
								</div>
								<div class="cutting-group__meta">
									<span>成品数量 {{ group.piece_count }} 支</span>
									<span>利用率 {{ formatUtilization(group.utilization) }}</span>
								</div>
							</div>
							<div v-if="group.warnings && group.warnings.length" class="cutting-group__warn">
								<span v-for="(w, wi) in group.warnings" :key="wi" class="cutting-group__warn-item">{{ w }}</span>
							</div>
							<table v-if="group.bins && group.bins.length" class="cutting-bin-table">
								<thead>
									<tr>
										<th class="col-idx">原料#</th>
										<th class="col-pieces">切段组合 (mm)</th>
										<th class="col-num">段数</th>
										<th class="col-num">占用 (mm)</th>
										<th class="col-num">余料 (mm)</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(bin, bi) in group.bins" :key="bi">
										<td class="col-idx">{{ bi + 1 }}</td>
										<td class="col-pieces">{{ (bin.pieces || []).join(' + ') }}</td>
										<td class="col-num">{{ (bin.pieces || []).length }}</td>
										<td class="col-num">{{ bin.used }}</td>
										<td class="col-num">{{ bin.waste }}</td>
									</tr>
								</tbody>
							</table>
						</div>

						<div class="cutting-footer" v-if="cuttingPlan && cuttingPlan.groups.length">
							<div class="cutting-footer__sign">
								<span>制单人：{{ (detail && detail.user_name) || '—' }}</span>
								<span>核对：____________</span>
								<span>日期：____________</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</common-body>
	</div>
</template>

<script>
import html2canvas from 'html2canvas'
import printJS from 'print-js'
import { getT } from '../assets/js/public.js'

export default {
	name: 'CuttingPrint',
	data() {
		return {
			orderIds: [],
			loadingStatus: true,
			detail: null,
			cuttingPlan: null,
			printDate: '',
		}
	},
	computed: {
		isMerge() {
			return this.orderIds.length > 1
		},
		ready() {
			return !this.loadingStatus && (this.detail || this.cuttingPlan)
		},
		orderNumbersText() {
			if (this.cuttingPlan && this.cuttingPlan.order_numbers && this.cuttingPlan.order_numbers.length) {
				return this.cuttingPlan.order_numbers.join('、')
			}
			return (this.detail && this.detail.order_number) || '—'
		},
		printTitle() {
			const cat =
				(this.cuttingPlan && this.cuttingPlan.category_name) ||
				(this.detail && this.detail.category_name) ||
				''
			const base = (cat ? cat : '') + '切料优化单'
			return this.isMerge ? base + '（揉单）' : base
		},
	},
	created() {
		this.reload()
	},
	methods: {
		formatMm(v) {
			if (v === undefined || v === null || v === '') return '未配置'
			return v + 'mm'
		},
		formatUtilization(v) {
			const n = Number(v)
			if (!Number.isFinite(n)) return '—'
			return (n * 100).toFixed(1) + '%'
		},
		parseOrderIds() {
			const q = this.$route.query || {}
			const fromIds = String(q.ids || '')
				.split(/[,，\s]+/)
				.map((s) => parseInt(s.trim(), 10))
				.filter((n) => n > 0)
			if (fromIds.length) return [...new Set(fromIds)]
			const single = parseInt(String(q.id || ''), 10)
			return single > 0 ? [single] : []
		},
		reload() {
			this.orderIds = this.parseOrderIds()
			this.printDate = getT(Date.now())
			if (!this.orderIds.length) {
				this.loadingStatus = false
				this.$message.warning('缺少订单参数')
				return
			}
			this.loadingStatus = true
			Promise.all([this.getDetail(), this.loadCuttingPlan()]).finally(() => {
				this.loadingStatus = false
			})
		},
		getDetail() {
			const that = this
			const id = that.orderIds[0]
			return that.$fetch('addons/hlm/api.Order/getOderDetails', {
				id,
			}).then(function(res) {
				if (res.code == 1) {
					const detail = res.data
					const orderTs = Number(detail.offertime) > 0 ? Number(detail.offertime) : Number(detail.createtime)
					detail.createTime = orderTs > 0 ? getT(orderTs * 1000) : '—'
					that.detail = detail
				}
			}).catch(function(error) {
				console.log(error)
			})
		},
		loadCuttingPlan() {
			const that = this
			return that.$fetch('addons/hlm/api.Order/getCuttingPlan', {
				ids: that.orderIds.join(','),
			}).then(function(res) {
				if (res.code == 1) {
					that.cuttingPlan = res.data
				}
			}).catch(function(error) {
				console.log(error)
			})
		},
		toImg() {
			const that = this
			if (!this.$refs.offerPrint) return
			html2canvas(this.$refs.offerPrint, {
				backgroundColor: '#ffffff',
				useCORS: true,
				scale: 2,
				windowHeight: document.body.scrollHeight,
			}).then((canvas) => {
				const url = canvas.toDataURL()
				printJS({
					printable: url,
					type: 'image',
					documentTitle: that.printTitle,
				})
			})
		},
		goBack() {
			// 回生产查询并恢复揉单勾选（sessionStorage）
			if (window.history.length > 1) {
				this.$router.back()
				return
			}
			this.$router.push('/factory')
		},
	},
}
</script>

<style src="../assets/css/cuttingPrint.css">
</style>
